<!-- Bottom Navigation Bar -->
<nav
    class="fixed bottom-0 left-0 right-0 z-40 bg-card print:hidden"
    aria-label="Mobile navigation"
>
    <div class="flex h-16 w-full">
        <!-- Navigation Items -->
        @for (item of getMainNavItems(); track item.id) {
            <!-- Group Item (with children) -->
            @if (item.type === 'group' && item.children && item.children.length > 0) {
                <a
                    class="flex-1 flex flex-col items-center justify-center gap-1.5 px-2 py-2 text-sm font-medium transition-colors"
                    [routerLink]="getItemLink(item)"
                    routerLinkActive="bottom-nav-active"
                    [routerLinkActiveOptions]="{ exact: false }"
                    #groupRla="routerLinkActive"
                    [attr.aria-label]="item.title"
                >
                    @if (item.icon) {
                        <mat-icon
                            [svgIcon]="getItemIcon(item, groupRla.isActive)"
                            [class.text-primary]="groupRla.isActive"
                            [class.text-gray-500]="!groupRla.isActive"
                            class="text-xl"
                        ></mat-icon>
                    }
                    <span
                        class="truncate"
                        [class.text-primary]="groupRla.isActive"
                        [class.text-gray-500]="!groupRla.isActive"
                    >
                        {{ item.title | transloco  }}
                    </span>
                </a>
            }

            <!-- Basic Item (single link) -->
            @if (item.type === 'basic') {
                <a
                    class="flex-1 flex flex-col items-center justify-center gap-1.5 px-2 py-2 text-sm font-medium transition-colors"
                    [routerLink]="getItemLink(item)"
                    routerLinkActive="bottom-nav-active"
                    [routerLinkActiveOptions]="{ exact: false }"
                    #itemRla="routerLinkActive"
                    [attr.aria-label]="item.title"
                >
                    @if (item.icon) {
                        <mat-icon
                            [svgIcon]="getItemIcon(item, itemRla.isActive)"
                            [class.text-primary]="itemRla.isActive"
                            [class.text-gray-500]="!itemRla.isActive"
                            class="text-xl"
                        ></mat-icon>
                    }
                    <span
                        class="truncate"
                        [class.text-primary]="itemRla.isActive"
                        [class.text-gray-500]="!itemRla.isActive"
                    >
                        {{ item.title }}
                    </span>
                </a>
            }
        }
    </div>
</nav>
